import Header from './components/Header';
import Hero from './components/Hero';
import FAQSection from './components/FAQSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FAQSection />
        <TopicsSection />
        <ContactSection />
        <MediaSection />
        <CardsSection />
        <UpdatesSection />
        <FeaturesSection />
        <IndexSection />
        <AboutSection />
        <CommentsSection />
        <RankingSection />
        <CarouselSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}